import React, { useState } from "react";
import Header from "components/Header";
import {
  TabContent,
  TabPane,
  Nav,
  NavItem,
  NavLink,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Modal,
} from "reactstrap";
import classnames from "classnames";
import { REVIEW_REPORT } from "apollo-client/mutations";

import { useQuery, useMutation, useApolloClient } from "@apollo/client";
import {
  GET_UNPROCESSED_ABUSE_REPORTS,
  GET_PROCESSED_ABUSE_REPORTS,
} from "apollo-client/queries";
import { Navigate } from "react-router-dom";
import { UnprocessedReports } from "components/unprocessedReports";
import { ProcessedReports } from "components/processedReports";
import { MainLayout } from "layout/MainLayout";
import { showErrorToast } from "toast-service";

export const AbuseReportsPage = () => {
  const {
    data: unprocessed_abuseReports,
    loading: loading_unprocessed_reports,
  } = useQuery(GET_UNPROCESSED_ABUSE_REPORTS);
  const { data: processed_abuseReports, loading: loading_processed_reports } =
    useQuery(GET_PROCESSED_ABUSE_REPORTS);
  const [activeTab, setActiveTab] = useState(1);

  const [completingReview, setCompletingReview] = useState(false);
  const [review, setReview] = useState({});

  const client = useApolloClient();

  // const reviewedReport = useMutation(ADD_CONTENT_VIDEOS, {
  //   variables: {
  //     courseId,
  //     url: youTubeLink,
  //     description: youTubeVideoDescription
  //   },
  //   update: (proxy, addContentVideosResponse) => {
  //     client.writeQuery({
  //       query: GET_YOUTUBE_VIDEO_LIST,
  //       data: { courses: addContentVideosResponse }
  //     });
  //     setPlusButtonToggle(!plusButtonToggle);
  //     setYouTubeLink("");
  //     setYouTubeVideoDescription("");
  //   }
  // });

  const [sendReviews] = useMutation(REVIEW_REPORT, {
    variables: {
      reportId: review.reportId,
      noteToBlag: review.noteToBlagoom,
      messageToContentCreator: review.messageToContentCreator,
      messageToReporter: review.messageToReporter,
      blockContent: review.blockContent,
    },
    onCompleted: () => {
      setReview({});
      setCompletingReview(false);
    },
    onError: (error) => {
      showErrorToast("Fehler beim Review");
    },
    refetchQueries: [
      GET_UNPROCESSED_ABUSE_REPORTS,
      GET_PROCESSED_ABUSE_REPORTS,
    ],
    awaitRefetchQueries: true,
  });

  const toggle = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };

  const sendReview = async () => {
    setReview({});
    setCompletingReview(false);
    await sendReviews();
  };

  return (
    <MainLayout>
      {review && (
        <Modal
          isOpen={completingReview}
          toggle={() => {
            setCompletingReview(false);
            setReview({});
          }}
        >
          <ModalHeader>
            {review.blockContent ? (
              <h2>Inhalt wird gesperrt !</h2>
            ) : (
              <h2>Inhalt wird nicht gesperrt</h2>
            )}
          </ModalHeader>
          <ModalBody>
            <h4>Nachricht an Melder </h4>
            <p> {review.messageToSender}</p>
            <h4>Nachricht an Content-Creator</h4>
            <p>{review.messageToContentCreator}</p>
            <h4>Notiz an Blaoom</h4>
            <p>{review.noteToBlagoom}</p>
          </ModalBody>
          <ModalFooter>
            <Button color="primary" onClick={() => sendReview()}>
              Fertigstellen
            </Button>
            <Button
              color="secondary"
              onClick={() => {
                setReview({});
                setCompletingReview(false);
              }}
            >
              Cancel
            </Button>
          </ModalFooter>
        </Modal>
      )}

      <Nav tabs>
        <NavItem>
          <NavLink
            className={classnames({ active: activeTab === "1" })}
            onClick={() => toggle(1)}
            style={{ cursor: "pointer" }}
          >
            Neu
          </NavLink>
        </NavItem>
        <NavItem>
          <NavLink
            className={classnames({ active: activeTab === "2" })}
            onClick={() => toggle(2)}
            style={{ cursor: "pointer" }}
          >
            Bereits bearbeitet
          </NavLink>
        </NavItem>
      </Nav>

      <TabContent activeTab={activeTab}>
        <TabPane tabId={1}>
          {!loading_unprocessed_reports &&
            unprocessed_abuseReports &&
            unprocessed_abuseReports.abuseReports && (
              <UnprocessedReports
                abuseReports={unprocessed_abuseReports.abuseReports}
                loading={loading_unprocessed_reports}
                completingReview={completingReview}
                setCompletingReview={setCompletingReview}
                setReview={setReview}
                review={review}
              />
            )}
        </TabPane>
        <TabPane tabId={2}>
          {processed_abuseReports && processed_abuseReports.abuseReports && (
            <ProcessedReports
              abuseReports={processed_abuseReports.abuseReports}
              loading={loading_processed_reports}
            />
          )}
        </TabPane>
      </TabContent>
    </MainLayout>
  );
};
